var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "13px",
    viewBox: "0 0 10 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Final",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modules",
    transform: "translate(-421.000000, -14168.000000)",
    stroke: "#012169",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(170.000000, 13949.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(25.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(80.000000, 147.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    transform: "translate(150.500000, 23.500000) rotate(-90.000000) translate(-150.500000, -23.500000) ",
    points: "146 21 150.5 26 155 21"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowright);
export default __webpack_public_path__ + "static/media/icon-arrowright.b31c3090a76c0e9d17723c63c4d2d443.svg";
export { ForwardRef as ReactComponent };